import React from 'react';
import PropTypes from 'prop-types';
import { TabOrganizer } from 'ui-kit';
import * as Styled from './old.styles';
import AmountText from './AmountText';

// Component is outdated use { Tabs } from 'modules' instead;
function TableTabsWrapper({
  hasTabs,
  amount,
  tableComponent,
  tabOptions,
  activeTab,
  onChangeTabs,
  mapComponent,
  mediaComponent,
  isManageAssignment,
  hasBorders,
  isHidden,
  mapEndpoint,
  fetchMapTotal,
  amountLabel,
}) {
  return (
    <Styled.Wrapper isManageAssignment={isManageAssignment}>
      <Styled.TabsPanelWrapper className="table-info" hasBorders={hasBorders} isHidden={isHidden}>
        {hasTabs && (
          <TabOrganizer
            tabsTitle={tabOptions?.map((item) => item.value)}
            selectedValue={tabOptions?.find((item) => item.id === activeTab)?.value ?? tabOptions?.[0]?.value}
            useActiveTab={onChangeTabs}
            borderLeft
            isBorder
            minWidth="162px"
            minHeight="40px"
            isMap="162px"
            isMargin="0 0"
            borderColor="#E0E0E0;"
            inputId="mapInputId"
          />
        )}
        <AmountText
          amount={amount}
          isManageAssignment={isManageAssignment}
          activeTab={activeTab}
          mapEndpoint={mapEndpoint}
          fetchMapTotal={fetchMapTotal}
          amountLabel={amountLabel}
        />
      </Styled.TabsPanelWrapper>
      {hasTabs ? (
        <Styled.TabsContent>
          <Styled.ComponentWrapper className={activeTab === 'list' ? 'active' : ''}>
            {tableComponent}
          </Styled.ComponentWrapper>
          <Styled.ComponentWrapper className={activeTab === 'map' ? 'active' : ''}>
            <Styled.MapWrapper>{mapComponent}</Styled.MapWrapper>
          </Styled.ComponentWrapper>
          {mediaComponent && (
            <Styled.ComponentWrapper className={activeTab === 'media' ? 'active' : ''}>
              {mediaComponent}
            </Styled.ComponentWrapper>
          )}
        </Styled.TabsContent>
      ) : (
        tableComponent
      )}
    </Styled.Wrapper>
  );
}

TableTabsWrapper.propTypes = {
  hasTabs: PropTypes.bool,
  amount: PropTypes.string.isRequired,
  tableComponent: PropTypes.node.isRequired,
  tabOptions: PropTypes.array,
  activeTab: PropTypes.number,
  onChangeTabs: PropTypes.func,
  mapComponent: PropTypes.node,
  mediaComponent: PropTypes.node,
  isManageAssignment: PropTypes.bool,
  hasBorders: PropTypes.bool,
  isHidden: PropTypes.bool,
  mapEndpoint: PropTypes.string,
  fetchMapTotal: PropTypes.bool,
  amountLabel: PropTypes.string,
};

TableTabsWrapper.defaultProps = {
  hasTabs: false,
  mapComponent: null,
  mediaComponent: null,
  tabOptions: [],
  activeTab: 1,
  onChangeTabs: () => {},
  isManageAssignment: false,
  hasBorders: false,
  isHidden: false,
  mapEndpoint: undefined,
  fetchMapTotal: false,
  amountLabel: 'items',
};

export default TableTabsWrapper;
